// @flow

export const getModuleNameFromLocation = (location: Location) => {
  const paths = location.pathname.split('/');

  // rule is that first path should represent the module name.
  return paths[1];
};
